module.exports = "/images/AssembleAPackage_2of2.jpg";